import axios from 'axios';
import http from 'api/http';

const PKCE_VERIFIER_KEY_PREFIX = 'ch_pkce_verifier';
const OAUTH_STATE_KEY = 'ch_oauth_state';

function base64UrlEncode(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function randomString(length = 64) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomValues = new Uint8Array(length);
  window.crypto.getRandomValues(randomValues);
  let result = '';
  for (let i = 0; i < randomValues.length; i++) result += charset[randomValues[i] % charset.length];
  return result;
}

async function sha256(plain) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

async function pkceChallengeFromVerifier(verifier) {
  const hashed = await sha256(verifier);
  return base64UrlEncode(hashed);
}

export async function buildAuthorizeUrl({ authorizationEndpoint, clientId, redirectUri }) {
  const state = randomString(32);
  const verifier = randomString(96);
  const challenge = await pkceChallengeFromVerifier(verifier);
  
  window.sessionStorage.setItem(`ch_pkce_challenge:${state}`, challenge);
  window.sessionStorage.setItem(`${PKCE_VERIFIER_KEY_PREFIX}${state}`, verifier);
  window.sessionStorage.setItem(OAUTH_STATE_KEY, state);

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: 'openid',
    state,
    code_challenge: challenge,
    code_challenge_method: 'S256',
  });
  //console.log({state, verifier, challenge, redirectUri});
  return `${authorizationEndpoint}?${params.toString()}`;
}

export async function exchangeCodeForToken({ tokenEndpoint, redirectUri, code, codeVerifier }) {
  if (!codeVerifier) throw new Error('Missing PKCE verifier');

  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    code,
    code_verifier: codeVerifier,
    redirect_uri: redirectUri,
  }).toString();

  return http.post(tokenEndpoint, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
}

export function consumePkceVerifierForState(returnedState) {
  if (!returnedState) throw new Error('Missing OAuth state');
  const key = `${PKCE_VERIFIER_KEY_PREFIX}${returnedState}`;
  const verifier = window.sessionStorage.getItem(key);
  window.sessionStorage.removeItem(key);

  if (!verifier) throw new Error('Missing PKCE verifier for returned state');
  return verifier;
}


// WEBPACK FOOTER //
// ./src/app/api/communityHubOAuth.js